import { IUpdateCustomerPhoneDTO } from 'modules/authentication/domain/dtos';
import { ICustomerPhoneRepository } from 'modules/authentication/domain/repositories';

export default class UpdateCustomerPhoneUseCase {
  constructor(private customerPhoneRepository: ICustomerPhoneRepository) {}

  public async execute(params: IUpdateCustomerPhoneDTO) {
    return this.customerPhoneRepository.update(params);
  }
}
